import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  getUserRowStyle,
  userColumns,
  SessonColumns,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";
import GridToolBar from "../GridToolBar";
import { useStore } from "../../hooks/store";
import { getUser, getUserCredit } from "../../utils/API/userMethods";
import { useNavigate } from "react-router";
import NewUserForm from "../Form/NewUserForm";
import { getSchool } from "../../utils/API/schoolMethods.js";
import { deleteSession, getSession } from "../../utils/API/unlimSession.js";
import NewSessinForm from "../Form/NewSessionForm.jsx";

export default function SessionGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [userData, setBiletData] = useState(undefined);
  const nav = useNavigate();

  const fetchUserData = () => {
    getSession().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    getUser().then(({ data, status }) => {
      store.setForm(<NewSessinForm />, fetchUserData, { userList: data });
    });
  };

  const handleRedactOpener = () => {
    const { id, user_id, device_name, session_id } = userData;
    getUser().then(({ data, status }) => {
      store.setForm(<NewSessinForm />, fetchUserData, {
        userList: data,
        id,
        user_id,
        device_name,
        session_id,
      });
    });
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchUserData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setBiletData(e.data);
  };

  const handleDelete = () => {
    const { session_id } = userData;

    deleteSession(session_id).then(({ data, status }) => {
      if (status === 200) {
        fetchUserData();
        store.setAlert(data, "success");

        return;
      }

      store.setAlert(data.error || data, "error");
    });
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchUserData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={userData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...SessonColumns]}
        getRowStyle={getUserRowStyle}
      />
    </div>
  );
}
